import { composeAPI } from "../Common/api";
import throughputComposition, {formatValue} from "./composition";


const noDecimalsNorThousands = formatValue(0/*precision*/, /*thousans*/false);

const thresholdToMbps = ([profile, thresholdKbps]) =>
  [profile, noDecimalsNorThousands(thresholdKbps / 1000)];

const keepToLength = (length) => ([profile, threshold]) =>
  profile +
  ' '.repeat(length - profile.length - threshold.length) +
  threshold

const toCells = row => row.split(/\s+/)


const reformatThresholds = input => {
  const [head, ...rows] = input.trim().split('\n');
  return [
    head.replace('-Kbps', '-Mbps'),
    ...rows.map(toCells).map(thresholdToMbps).map(keepToLength(head.length)),
  ].join('\n');
}

const loadAll = () =>
  ifCl.run('show profile throughput').then(reformatThresholds);

export const composedAPI = composeAPI({loadAll, ...throughputComposition});
